<template>
  <div>
    <div class="container">
      <div class="select-agreement">
        <span>请选择采购协议：</span>
        <eui-btn type="text" @click="openSelectAgreement">
          {{
            agreementInfo.agreementName
              ? agreementInfo.agreementName
              : '选择框架协议'
          }}
        </eui-btn>
      </div>

      <el-form
        ref="skuForm"
        :rules="rules"
        :model="newForm"
        class="form-content"
        size="small"
      >
        <div>
          <div
            v-for="(item, index) in newForm.recordsNew"
            class="table-content"
          >
            <div class="top">
              <div class="top-header-left">
                <div>需求计划编号：</div>
                {{ item.purchaseDemandCode }}
                <div style="margin-left: 55px">需求计划名称：</div>
                {{ item.purchaseDemandName }}
              </div>
              <div class="top-header-right">
                <div>
                  <div class="approver">
                    申请人：
                    <span>{{ item.createMemberName }}</span>
                  </div>
                </div>
                <div class="order-status-text">
                  申请时间：{{ item.createTime }}
                </div>
              </div>
            </div>
            <el-table
              :show-header="false"
              :data="item.purchaseDemandItemSelectedListVOS"
              border
              max-height="455"
              style="width: 100%"
              :header-cell-style="{
                background: '#F5F5F5',
                borderColor: '#d9d9d9',
              }"
              :cell-style="{ borderColor: '#d9d9d9' }"
              current-row-key="index"
              class="validate-table"
              align="center"
              fit
            >
              <el-table-column label="序号" width="50px" align="center">
                <template #default="scope">
                  <div class="choose-btn">
                    <span>{{ scope.$index + 1 }}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                label="物料描述"
                min-width="190px"
                prop="productName"
                align="center"
              >
                <template #default="scope">
                  <div class="item-content">
                    <div class="label">物料描述</div>
                    <!-- <p>{{ scope.row.categoryDesc }}</p> -->
                    <div
                      class="item-img-content-name in2clamp"
                      style="line-height: 16px; -webkit-line-clamp: 4"
                    >
                      <el-tooltip
                        class="item"
                        effect="dark"
                        :content="scope.row.categoryDesc"
                        placement="top"
                      >
                        <div class="font break">
                          <div class="font break">
                            {{ scope.row.categoryDesc }}
                          </div>
                        </div>
                      </el-tooltip>
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                label="需求数量"
                min-width="156px"
                prop="quantity"
                align="center"
              >
                <template #default="{ row }">
                  <div class="item-row">
                    <div class="item-row-column">
                      <div class="item-row-column-desc">需求数量</div>
                      <div class="item-row-column-content">
                        {{ row.quantity }}
                      </div>
                    </div>
                    <div class="item-row-column">
                      <div class="item-row-column-desc">计量单位</div>
                      <div class="item-row-column-content">
                        {{ row.baseUnitName }}
                      </div>
                    </div>
                    <div class="item-row-column">
                      <div class="item-row-column-desc" style="color: #e50113">
                        剩余可采购数量
                      </div>
                      <div
                        class="item-row-column-content"
                        style="color: #e50113"
                      >
                        {{ row.remainingQuantity }}
                      </div>
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                label="商品"
                min-width="272px"
                prop="remainingQuantity"
                align="center"
              >
                <template #default="{ row }">
                  <div
                    v-if="row.purchaseDemandItemSkuSelectedListVOS"
                    class="item-img-content"
                  >
                    <div class="item-img-content-top">
                      <div class="item-img-content-row">
                        <div
                          class="item-img-content-column"
                          style="border: 1px solid #d9d9d9"
                        >
                          <!--                             v-lazy="
                              row.purchaseDemandItemSkuSelectedListVOS[0]
                                .productImageUrl
                            " -->
                          <img
                            :src="
                              row.purchaseDemandItemSkuSelectedListVOS[0]
                                .productImageUrl
                            "
                            alt=""
                            class="img-relative"
                          />
                        </div>
                        <div
                          v-if="row.purchaseDemandItemSkuSelectedListVOS"
                          class="item-img-content-column"
                        >
                          <div
                            class="item-img-btn"
                            @click="handleSelectProduct(row)"
                          >
                            修改商品
                          </div>
                        </div>
                      </div>
                      <div
                        class="item-img-content-row"
                        style="margin-left: 10px"
                      >
                        <div
                          class="item-img-content-column"
                          style="margin-bottom: 12px"
                        >
                          <div class="item-img-content-name in2clamp">
                            <el-tooltip
                              class="item"
                              effect="dark"
                              :content="
                                row.purchaseDemandItemSkuSelectedListVOS[0]
                                  .productSkuName
                              "
                              placement="top"
                            >
                              <div class="font break">
                                <div class="font break">
                                  {{
                                    row.purchaseDemandItemSkuSelectedListVOS[0]
                                      .productSkuName
                                  }}
                                </div>
                              </div>
                            </el-tooltip>
                          </div>
                        </div>

                        <div class="item-img-content-column">
                          <div
                            v-if="
                              row.purchaseDemandItemSkuSelectedListVOS &&
                              row.purchaseDemandItemSkuSelectedListVOS[0]
                                .productSkuCode.length <= 38
                            "
                            class="item-img-content-name"
                            style="color: #999999; line-height: 1"
                          >
                            商品编码：{{
                              row.purchaseDemandItemSkuSelectedListVOS[0]
                                .productSkuCode
                            }}
                          </div>
                          <el-tooltip
                            v-if="
                              row.purchaseDemandItemSkuSelectedListVOS &&
                              row.purchaseDemandItemSkuSelectedListVOS[0]
                                .productSkuCode &&
                              row.purchaseDemandItemSkuSelectedListVOS[0]
                                .productSkuCode.length > 38
                            "
                            class="item"
                            effect="dark"
                            :content="
                              row.purchaseDemandItemSkuSelectedListVOS[0]
                                .productSkuCode
                            "
                            placement="top"
                          >
                            <div
                              class="item-img-content-name in3clamp"
                              style="color: #999999; line-height: 1"
                            >
                              商品编码：{{
                                row.purchaseDemandItemSkuSelectedListVOS[0]
                                  .productSkuCode
                              }}
                            </div>
                          </el-tooltip>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-else class="choose-btn">
                    <eui-btn
                      :disabled="!agreementInfo.agreementId"
                      @click="handleSelectProduct(row)"
                      >选择商品</eui-btn
                    >
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                label="采购数量"
                min-width="112px"
                align="center"
              >
                <template #default="scope">
                  <el-form-item
                    :prop="`recordsNew[${index}].purchaseDemandItemSelectedListVOS[${scope.$index}].purchaseNum`"
                    :rules="rules.purchaseNum"
                  >
                    <div class="purchase-number" style="margin-bottom: 10px">
                      采购数量：
                    </div>
                    <el-input
                      v-model.trim="scope.row.purchaseNum"
                      :disabled="
                        !scope.row.purchaseDemandItemSkuSelectedListVOS
                      "
                      maxlength="10"
                      class="edit-input"
                      size="small"
                      placeholder="需求数量"
                      @change="
                        handleNumChange(
                          scope.row,
                          scope.row.purchaseDemandItemSkuSelectedListVOS[0],
                          scope.$index
                        )
                      "
                    ></el-input>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column width="108px">
                <template #default="{ row }">
                  <div class="delete">
                    <eui-btn type="text" @click="handleDelete(row)"
                      >删除</eui-btn
                    >
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </el-form>
    </div>
    <div id="show-btn" class="button-handle">
      <eui-btn type="secondary" @click="handleGoBack">返回</eui-btn>
      <div>
        <eui-btn type="secondary" @click="handleGoBack">取消</eui-btn>
        <eui-btn :disabled="!agreementInfo.agreementId" @click="handleOrder"
          >生成订单</eui-btn
        >
      </div>
    </div>

    <!-- <div
      v-if="isFixed"
      class="button-handle is-fixed"
      style="z-index: 1000; background-color: #ffffff; height: 60px"
    >
      <div class="is-fixed-wrap-left"></div>
      <div class="is-fixed-wrap">
        <div class="reset" @click="handleGoBack">取 消</div>
        <el-button
          :disabled="!agreementInfo.agreementId"
          class="query"
          @click="handleOrder"
        >
          生成订单
        </el-button>
      </div>
    </div> -->

    <eDialog
      :dialog-title="dialogTitle"
      :show-btn="false"
      :center-dialog-visible="visible"
      :popup-width="'800px'"
      show-close-btn
      @updateVisible="closeProduct"
      @resetPopupData="closeProduct"
    >
      <e-search
        :data="productSearch"
        :field-list="productSearchList"
        @handleFilter="handleSearch"
        @handleReset="handleReset"
      ></e-search>
      <e-table-list
        style="margin-top: 20px"
        :table-data="tableData"
        :table-label="productTableLabel"
        max-height="400px"
      >
        <template #productInfo="{ scope }">
          <div class="product-info">
            <!-- v-lazy="scope.row.defaultimage" -->
            <img class="product-img" :src="scope.row.defaultimage" alt />
            <div class="product-info-right">
              <div v-if="scope.row.skuname.length < 48" class="title two-line">
                {{ scope.row.skuname }}
              </div>
              <el-tooltip
                v-else
                class="item"
                effect="dark"
                :content="scope.row.skuname"
                placement="top"
              >
                <div class="title two-line">{{ scope.row.skuname }}</div>
              </el-tooltip>
              <el-tooltip
                class="item"
                effect="dark"
                :content="scope.row.skucode"
                placement="bottom"
              >
                <div class="num break">单品编号：{{ scope.row.skucode }}</div>
              </el-tooltip>
              <div
                v-if="scope.row.suppliercompanyname.length < 11"
                class="provider"
              >
                供应商：{{ scope.row.suppliercompanyname }}
              </div>
              <el-tooltip
                v-else
                class="item"
                effect="dark"
                :content="scope.row.suppliercompanyname"
                placement="top"
              >
                <div class="provider break">
                  供应商：{{ scope.row.suppliercompanyname }}
                </div>
              </el-tooltip>
            </div>
          </div>
        </template>
        <template #delivertime="{ scope }">
          <span>{{ `${scope.row.delivertime}天内发货` }}</span>
        </template>
        <template #price="{ scope: { row } }">
          <div
            v-if="row.price && row.pricetype === 4"
            class="jc-price-container"
          >
            <img
              height="20"
              width="44"
              src="../../../../../assets/img/product/together-price-icon-small@2x.png"
              alt="集采价"
            />
            <div class="jc-price">
              ￥
              <span>{{ row.price.toFixed(2) }}</span>
            </div>
          </div>
          <span v-else style="color: #f0250f">¥ {{ row.price }}</span>
        </template>
        <template #handle="{ scope }">
          <eui-btn type="weak" @click="handleSelected(scope.row)">选中</eui-btn>
        </template>
      </e-table-list>
      <div class="pagination">
        <el-pagination
          :pager-count="5"
          :page-sizes="[10, 20, 30]"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="productSearch.pageNum"
          :total="productTotal"
          :page-size.sync="productSearch.pageSize"
          prev-text="上一页"
          next-text="下一页"
          @size-change="handleProductSizeChange"
          @current-change="handleProductCurrentChange"
        ></el-pagination>
      </div>
    </eDialog>

    <!-- 框架协议弹框 -->
    <e-dialog
      class="agreement-dialog"
      :dialog-title="'选择框架协议'"
      :dialog-type="''"
      :center-dialog-visible="agreementVisible"
      :popup-width="'1000px'"
      :show-btn="false"
      show-close-btn
      @resetPopupData="resetPopupDataAgreement"
    >
      <!-- searct -->
      <e-search
        :data="agreementData"
        :list-type-info="listTypeInfo"
        :width="filterInfo.width"
        :field-list="agreementList"
        @handleFilter="handleAgreementFilter"
        @handleReset="handleAgreementReset"
      ></e-search>
      <!-- table -->
      <e-table-list
        style="margin-top: 20px"
        :table-data="agreementTableData"
        :table-label="agreementTableLabel"
        :index-show="true"
      >
        <template #code="tData">
          <eui-btn type="text" @click="handleCodeDetail(tData.scope.row)">
            {{ tData.scope.row.agreementCode }}
          </eui-btn>
        </template>
        <template #options="tData">
          <eui-btn type="text" @click="handleSelectAgreement(tData.scope.row)"
            >执行框架协议</eui-btn
          >
        </template>
      </e-table-list>
      <!-- 分页 -->
      <div class="pagination">
        <el-pagination
          :pager-count="5"
          :page-sizes="[10, 20, 30]"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="agreementData.pageNum"
          :total="agreementDataTotal"
          :page-size.sync="agreementData.pageSize"
          prev-text="上一页"
          next-text="下一页"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </div>
    </e-dialog>
  </div>
</template>
<script>
import eDialog from '@/modules/projectA/components/common/e-dialog';
import eSearch from '@/modules/projectA/components/common/e-search.vue';
import eTableList from '@/modules/projectA/components/common/e-table-list';
import Api from '@/modules/projectA/api/purchase/index';
import _ from 'lodash';
import { orderBaseUrl } from '@/modules/projectA/api/config';
export default {
  name: 'AllOrder',
  components: {
    eDialog,
    eSearch,
    eTableList,
    eDialog,
  },
  props: {
    changeOrderHandle: {
      type: Function,
      require: true,
    },
  },
  data() {
    return {
      agreementData: {
        agreementName: '',
        agreementCode: '',
        supplierCompanyName: '',
        specializedSign: 1, // 专属商城
        externalStatus: 2, // 已生效
        createTime: '',
        startTime: '',
        endTime: '',
        categoryDesc: '',
        pageNum: 1,
        pageSize: 10,
      },
      cloneAgreementData: {},
      agreementDataTotal: 0,
      agreementTableData: [],
      agreementTableLabel: [
        {
          label: '框架协议编号',
          align: 'center',
          slot: 'code',
        },
        {
          label: '框架协议名称',
          param: 'agreementName',
          align: 'center',
        },
        {
          label: '供应商',
          param: 'supplierCompanyName',
          align: 'center',
        },
        {
          label: '协议有效期',
          param: 'endDate',
          align: 'center',
          width: '200',
          render: (row) => {
            return `${row.startDate} - ${row.endDate}`;
          },
        },
        { label: '操作', align: 'center', slot: 'options', width: '130' },
      ],
      agreementList: [
        {
          label: '框架协议编号',
          type: 'input',
          value: 'agreementCode',
        },
        {
          label: '框架协议名称',
          type: 'input',
          value: 'agreementName',
        },
        {
          label: '供应商',
          type: 'input',
          value: 'supplierCompanyName',
        },
        {
          label: '协议有效期',
          type: 'date',
          value: 'createTime',
          defaultTime: ['00:00:00', '23:59:59'],
          valueFormat: 'yyyy-MM-dd',
          dateType: 'daterange',
        },
      ],
      filterInfo: {
        width: {
          labelWidth: 100,
          itemWidth: 180,
        },
      },
      listTypeInfo: {
        purchaseModeTypeList: [
          { name: '选品下单', id: 1 },
          { name: '询比价', id: 2 },
          { name: '自行招标', id: 3 },
          { name: '委托招标', id: 4 },
          { name: '执行框架协议', id: 5 },
        ],
      },
      agreementVisible: false,
      tipWord: '',
      checkCompanyAttrFlag: false,
      dialogType: '',
      dialogTitle: '选择商品',
      isDoc: '',
      dialogContent: '',
      visible: false,
      underlineName: '',
      underlineOrderId: '',
      orderStatusNum: '',
      onLinePayAndCompanyPay: '', // 在线支付与担保支付组合
      loading: true,
      noDataFlag: false,
      resData: {},
      formInline: {
        projectnos: null, // 采购申请号 目前没有
        orderNo: null, // 订单编号
        supplierCompany: null, // 供应商名称
        time: null,
        startTime: null,
        endTime: null,
        memberRealName: null, // 下单人姓名
        shipmentType: null, // 配送方式 1：配送　　2：自提
        orderStatus: null,
        otherPay: 0, // 0不使用1使用易权通
        endAmount: null,
        startAmount: null,
        pageNum: 1,
        pageSize: 5,
      },
      records: [],
      form: {},
      tableData: [],
      /* rules: {
        purchaseNum: [{ validator: validatePurchaseNum, trigger: ['blur'] }],
        // purchaseQuantity: [{ validator: validatePurchaseNum, trigger: ["blur"] }],
      }, */
      rules: {
        purchaseNum: [
          { validator: this.validatePurchaseNum, trigger: ['blur', 'change'] },
        ],
        categoryDesc: {
          required: true,
          message: '请输入名称',
          trigger: 'blur',
        },
      },
      count: 1,
      busy: true,
      productSearch: {
        skuName: '', // 精确查
        skuCode: '', // 商品编号
        supplierCompanyName: '', // 供应商
        pageNum: 1,
        pageSize: 10,
        exportStatus: 101,
      },
      productTotal: 0,

      productTableData: [],
      productTableLabel: [
        {
          label: '商品信息',
          align: 'center',
          slot: 'productInfo',
          minWidth: 300,
        },
        {
          label: '品牌',
          align: 'center',
          param: 'brandname',
          width: 70,
        },
        {
          label: '发货时间',
          align: 'center',
          slot: 'delivertime',
          width: 90,
        },
        {
          label: '单位',
          align: 'center',
          param: 'unitvalue',
          width: 70,
        },
        {
          label: '含税价格（元）',
          align: 'center',
          slot: 'price',
          width: 200,
        },
        {
          label: '操作',
          align: 'center',
          slot: 'handle',
          width: 110,
          fixed: 'right',
        },
      ],
      productSearchList: [
        {
          label: '供应商名称',
          type: 'input',
          value: 'supplierCompanyName',
        },
        {
          label: '商品名称',
          type: 'input',
          value: 'skuName',
        },
        {
          label: '商品编码',
          type: 'input',
          value: 'skuCode',
        },
      ],

      isFixed: true,
      purchaseRow: {},
      taxInfo: {},

      agreementInfo: {},

      purchaseDemandIdList: '',
      newForm: {
        recordsNew: [],
      },
    };
  },
  created() {
    this.cloneAgreementData = _.cloneDeep(this.agreementData);
    console.log(this.cloneAgreementData, 'this.cloneAgreementData');
    // this.selectOrder();
    this.deleteProduct().then((res) => {
      this.getOrderList();
    });
  },
  /* mounted() {
    this.checkShow();
    window.addEventListener('scroll', this.initHeight);
  },
  destroyed() {
    window.removeEventListener('scroll', this.initHeight);
  }, */
  methods: {
    validatePurchaseNum(rule, value, callback) {
      console.log(rule, 'rule', value);
      let remainingQuantity = 0;
      const attr = rule.field;
      const regex = /\[(.+?)\]/g;
      const arr = attr.match(regex);
      for (let i = 0; i < arr.length; i++) {
        arr[i] = JSON.parse(arr[i]);
      }
      // const [first, last] = arr;
      const first = arr[0][0];
      const last = arr[1][0];
      console.log(first, last);
      const item =
        this.newForm.recordsNew[first].purchaseDemandItemSelectedListVOS[last];
      remainingQuantity = item.remainingQuantity;
      /* const ruleArr = rule.field.split(".");
      console.log(ruleArr);
      const index = ruleArr[1];
      console.log(index);
      console.log(ruleArr[2], "ruleArr[1]"); */

      /* console.log(rule.field, 'rule');
        const ruleArr = rule.field.split('.');
        console.log(ruleArr);
        const index = ruleArr[2];
        const item = this.formData.tableData[index];
        remainingQuantity = item.remainingQuantity; */
      /* const item = this.records[this.recordsIndex].purchaseDemandItemSelectedListVOS[index];
      console.log(item, "item");
      remainingQuantity = item.remainingQuantity; */

      if (!value || value == 0) {
        return callback(new Error('请输入采购数量'));
      }
      if (!/^-?\d+(\.\d{1,3})?$/.test(value)) {
        return callback(new Error('采购数量为保留三位小数'));
      }
      console.log(value, remainingQuantity);
      if (value > remainingQuantity) {
        return callback(new Error(`采购数量小于等于剩余采购数量`));
        // return callback(new Error(`采购数量最多${remainingQuantity}`));
      }
      callback();
    },
    handleCodeDetail(row) {
      this.$router.push({
        path: '/demand/execute/agreementDetail',
        query: {
          agreementId: row.agreementId,
        },
      });
    },
    // 获取框架协议商品
    async getQueryEpecPriceByPage(params) {
      try {
        const res = await Api.queryEpecPriceByPage(params);
        const { data } = res;
        const skuIds = data.records.map((item) => item.skuId);
        this.productTotal = data.total;

        // 处理 搜索不到商品的情况
        if (skuIds.length === 0) {
          this.tableData = [];
          return false;
        }

        const goodsRes = await Api.queryProductPage2({
          pageNum: 1,
          pageSize: 10,
          skuIds,
        });
        this.tableData = [...goodsRes.data.list];
      } catch (err) {
        console.log(err);
      }
    },
    handleProductCurrentChange(val) {
      this.productSearch.pageNum = val;
      this.getQueryEpecPriceByPage(this.productSearch);
    },
    handleProductSizeChange(val) {
      this.productSearch.pageNum = 1;
      this.productSearch.pageSize = val;
      this.getQueryEpecPriceByPage(this.productSearch);
    },
    handleReset() {
      this.productSearch.skuName = '';
      this.productSearch.skuCode = '';
      this.productSearch.supplierCompanyName = '';
      this.productSearch.pageNum = 1;
      this.productSearch.exportStatus = 101;
      this.getQueryEpecPriceByPage(this.productSearch);
    },
    async handleSearch(val) {
      this.productSearch = { ...val };
      this.getQueryEpecPriceByPage(this.productSearch);
    },

    // 采购商-框架协议分页列表查询
    async queryAgreementForPurchaseByPage(params) {
      try {
        delete params.createTime;
        const res = await Api.queryAgreementForPurchaseByPage(params);
        if (res.code == '200') {
          this.agreementTableData = res.data.records;
          this.agreementDataTotal = res.data.total;
        }
      } catch (err) {
        console.log(err);
      }
    },
    // 返回
    handleGoBack() {
      this.$router.back();
    },
    // 打开框架协议弹框
    openSelectAgreement() {
      this.agreementVisible = true;
      this.agreementData = { ...this.cloneAgreementData };
      this.queryAgreementForPurchaseByPage(this.agreementData);
    },
    // 选中框架协议
    handleSelectAgreement(row) {
      this.productSearch.agreementId = '';
      console.log(row, '协议内容');
      this.agreementInfo = { ...row };
      this.productSearch.agreementId = this.agreementInfo.agreementId;
      this.agreementVisible = false;
      this.deleteProduct().then((res) => {
        this.getOrderList();
      });
    },
    resetPopupDataAgreement() {
      this.agreementVisible = false;
    },
    // 查询
    handleAgreementFilter(val) {
      this.agreementData = { ...val };
      this.agreementData.pageNum = 1;
      this.agreementData.startDate = val.createTime ? val.createTime[0] : '';
      this.agreementData.endDate = val.createTime ? val.createTime[1] : '';
      this.queryAgreementForPurchaseByPage(this.agreementData);
    },
    // 重置
    handleAgreementReset() {
      this.agreementData = { ...this.cloneAgreementData };
      this.queryAgreementForPurchaseByPage(this.agreementData);
    },
    // 框架协议详情
    handleAgreementDetail() {},
    // 框架协议弹框分页
    handleCurrentChange(val) {
      this.agreementData.pageNum = val;
      this.queryAgreementForPurchaseByPage(this.agreementData);
    },
    handleSizeChange(val) {
      this.agreementData.pageNum = 1;
      this.agreementData.pageSize = val;
      this.queryAgreementForPurchaseByPage(this.agreementData);
    },

    initHeight() {
      const scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      const height =
        document.documentElement.clientHeight || document.body.clientHeight;
      const div = document.getElementById('show-btn');
      const divToTop = div.offsetTop;
      // console.log(divToTop);
      if (scrollTop + height < divToTop) {
        this.isFixed = true;
      } else {
        this.isFixed = false;
      }
    },
    checkShow() {
      const div = document.getElementById('show-btn');
      const divToTop = div.offsetTop;
      // console.log(divToTop);
      const height =
        document.documentElement.clientHeight || document.body.clientHeight;
      const scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;

      if (height + scrollTop > divToTop) {
        this.isFixed = false;
      } else {
        this.isFixed = true;
      }
    },
    // 查询
    /* async selectOrder() {
      const res = await Api.queryProductPage2({
        ...this.productSearch,
      });
      if (res.code == '200') {
        this.tableData = [...res.data.list]; // 数组拼接，得到拼接后的数据
        this.total = res.data.list.length;
      } else {
        this.$message.error(res.message);
      }
    }, */

    loadMore() {
      /* this.busy = true;
      //把busy置位true，这次请求结束前不再执行
      setTimeout(() => {
        //订单列表
        this.productSearch.pageNum = this.count++;
        this.busy = true;
        this.selectOrder();
        //调用获取数据接口，并且传入一个true，让axios方法指导是否需要拼接数组。
      }, 500); */
    },
    // 修改商品
    handleEditProduct(item) {
      this.purchaseRow = item;
      this.visible = true;
    },
    /* handleOrder() {
      let flag = true;
      for (let i = 0; i < this.records.length; i++) {
        this.$refs['skuForm'][i].validate(val => {
          if (!val) {
            flag = val;
          }
          console.log(flag, val, 'valval');
          console.log(flag, 'flagflag');
        });
      }

      console.log(flag, 'flagflagflagflag');
      if (flag) {
        this.$router.push({
          path: '/order',
          query: { flag: 'requestPool', purchaseDemandIdList: this.purchaseDemandIdList },
        });
      }
    }, */
    handleOrder() {
      this.$refs.skuForm.validate((val) => {
        if (val) {
          window.open(`${orderBaseUrl}/order?from=v&flag=requestPool&purchaseDemandIdList=${this.purchaseDemandIdList}`, '_blank');}
      });

    },
    closeProduct() {
      this.visible = false;
      this.productSearch = {
        skuName: '', // 精确查
        skuCode: '', // 商品编号
        supplierCompanyName: '', // 供应商
        pageNum: 1,
        pageSize: 10,
        exportStatus: 101,
      };
    },
    async handleSelected(val) {
      // 获得税率信息
      const param = {
        taxRateId: val.taxrateid,
      };
      const res1 = await Api.getProductRate(param);

      if (res1.code == '200') {
        this.taxInfo = res1.data;

        const params = {
          // purchaseDemandProductChooseAO :{
          protocolId: this.agreementInfo.agreementId,
          protocolCode: this.agreementInfo.agreementCode,
          brandName: val.brandname,
          categoryId: val.categoryid,
          categoryName: val.category,
          conversionUnitRatio: '',
          price: val.price,
          productId: val.productid,
          productImageUrl: val.defaultimage,
          productSkuCode: val.skucode,
          productSkuId: val.skuid,
          productSkuName: val.skuname,
          purchaseCompanyId: val.suppliercompanyid,
          purchaseCompanyName: val.suppliercompanyname,
          purchaseDemandId: this.purchaseRow.purchaseDemandId,
          purchaseDemandItemId: this.purchaseRow.purchaseDemandItemId,
          purchaseQuantity: this.purchaseRow.purchaseQuantity,
          salesTaxNo: this.taxInfo.taxRateCode,
          salesTaxRate: this.taxInfo.taxRate,
          subtotal: '',
          supplierCompanyId: val.suppliercompanyid,
          unitCode: '',
          unitName: val.unitvalue,
          supplierCompanyName: val.suppliercompanyname,
          productSkuOptionsStr: val.specificationstr,
          productSkuOptions: val.specificationsList,
          purchaseDemandCode: this.purchaseRow.purchaseDemandCode,
          // }
        };

        const res = await Api.choosePurchaseDemandProductPc(params);

        if (res.code === '200') {
          this.visible = false;
          this.getOrderList();
        }
      }
    },
    // 选择商品
    handleSelectProduct(item) {
      this.purchaseRow = item;
      this.visible = true;
      this.productSearch.agreementId = this.agreementInfo.agreementId;
      this.productSearch.supplierCompanyId =
        this.agreementInfo.supplierCompanyId;
      this.getQueryEpecPriceByPage(this.productSearch);
    },
    /* async getOrderList() {
      let params = {};
      let res = await Api.queryPurchaseDemandSelected(params);
      this.records = res.data;
    }, */
    async deleteProduct() {
      await Api.deletePurchaseDemandItemSkuSelected({});
    },
    async getOrderList() {
      try {
        const params = {};
        const res = await Api.queryPurchaseDemandSelectPc(params);
        const goods = [];
        res.data.forEach((item) => {
          /* const itemProduct = item.purchaseDemandItemSelectedListVOS[0];
          if (itemProduct?.purchaseDemandItemSkuSelectedListVOS?.length) {
            item.purchaseDemandItemSelectedListVOS[0].purchaseNum =
              item.purchaseDemandItemSelectedListVOS[0]?.purchaseDemandItemSkuSelectedListVOS[0]
                ?.purchaseQuantity || item.purchaseDemandItemSelectedListVOS[0].remainingQuantity;
            if (
              item.purchaseDemandItemSelectedListVOS[0]?.purchaseDemandItemSkuSelectedListVOS[0]
                ?.purchaseQuantity === 0
            ) {
              Api.queryPurchaseNumPc({
                purchaseDemandItemSkuId:
                  item.purchaseDemandItemSelectedListVOS[0]?.purchaseDemandItemSkuSelectedListVOS[0]
                    .purchaseDemandItemSkuId,
                purchaseQuantity: item.purchaseDemandItemSelectedListVOS[0].remainingQuantity,
              });
            }
          } */

          const itemProducts = item.purchaseDemandItemSelectedListVOS;
          itemProducts.forEach((product) => {
            goods.push(product);
            if (product.purchaseDemandItemSkuSelectedListVOS?.length) {
              product.purchaseNum =
                product?.purchaseDemandItemSkuSelectedListVOS[0]
                  ?.purchaseQuantity || product.remainingQuantity;
              if (
                product?.purchaseDemandItemSkuSelectedListVOS[0]
                  ?.purchaseQuantity === 0
              ) {
                Api.queryPurchaseNumPc({
                  purchaseDemandItemSkuId:
                    product?.purchaseDemandItemSkuSelectedListVOS[0]
                      .purchaseDemandItemSkuId,
                  purchaseQuantity: product.remainingQuantity,
                });
              }
            }
          });
        });
        this.purchaseDemandIdList = JSON.stringify(
          goods.map((item) => item.purchaseDemandItemId)
        );
        console.log(this.purchaseDemandIdList, 'this.purchaseDemandIdList');
        this.records = res.data;
        this.newForm.recordsNew = [...res.data];
      } catch (err) {
        console.log(err);
      }
    },
    async handleDelete(val) {
      const params = {
        isSelected: 0,
        purchaseCompanyId: val.purchaseCompanyId,
        purchaseDemandItemId: val.purchaseDemandItemId,
      };

      const res = await Api.deletePurchaseDemandItemPc(params);

      if (res.code === '200') {
        this.$message({
          type: 'success',
          message: '删除成功',
        });
        this.getOrderList();
      }
    },
    async getRateInfo(val) {
      const params = {
        taxRateId: val,
      };
      const res = await Api.getProductRate(params);

      if (res.code === '200') {
        this.taxInfo = res.data;
        console.log('this.taxInfo', this.taxInfo);
      }
    },
    handleNumChange(val, skuItem) {
      // 调接口将采购数据传给订单11/14
      const params = {
        purchaseDemandItemSkuId: skuItem.purchaseDemandItemSkuId,
        purchaseQuantity: val.purchaseNum,
        // purchaseQuantity: val.purchaseQuantity,
      };
      Api.queryPurchaseNumPc(params);
    },

    /* async handleNumChange(value, skuItem, index) {
      console.log(value, skuItem, index);
      //调接口将采购数据传给订单11/14
      for (let i = 0; i < this.records.length; i++) {
        this.$refs['skuForm'][i].validate(async val => {
          console.log('i === index', i, index);
          console.log('val', i, val);
          if (i === index && val) {
            const params = {
              purchaseDemandItemSkuId: skuItem.purchaseDemandItemSkuId,
              purchaseQuantity: value.purchaseNum
            };
            const res = await Api.queryPurchaseNumPc(params);
          }
        });
      }
    } */
  },
};
</script>
<style lang="scss">
.re-order {
  padding: 20px;
}
.btn-order-self {
  font-size: 14px;
  font-weight: 400;
  cursor: pointer;
  width: 80px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  background: #2587ff;
  color: #ffffff;
  margin-left: 100px;
  margin-top: 30px;
  padding: 0;
  border-radius: 0;
  &:hover,
  :active {
    background-color: #126edf;
  }
}
.el-tooltip__popper {
  border-radius: 0;
}
</style>
<style lang="scss" scoped>
@import '@/assets/css/theme.scss';
::v-deep .jc-price-container {
  display: inline-flex;
  align-items: center;
  justify-content: flex-start;
  img {
    position: relative;
    z-index: 1;
  }
  .jc-price {
    height: 18px;
    padding: 0 10px 0 20px;
    margin-left: -20px;
    align-self: flex-end;
    background: #ffeac9;
    line-height: 18px;
    font-size: 14px;
    font-weight: 400;
    border-radius: 4px;
    color: #f0250f;
  }
}
.table-content {
  margin-top: 20px;
  &:first-child {
    margin-top: 0;
  }
}
.form-content {
  line-height: 1;
  &:first-child {
    margin-top: 0;
  }
  ::v-deep .el-table--border {
    &::after {
      background: #d9d9d9;
    }
  }
  ::v-deep .el-table {
    .el-table__cell {
      height: 110px;
    }
    .cell {
      height: 100%;
      text-align: left;
      .item-content {
        line-height: 1;
        .label {
          margin-bottom: 8px;
          color: #999;
        }
        p {
          line-height: 18px;
        }
      }
      .el-form-item {
        display: flex;
        justify-content: center;
        font-size: 12px;
        .el-form-item__label {
          padding: 0px 0 0px;
          line-height: 1;
        }
        .el-form-item__error {
          padding-top: 6px;
        }
        .el-form-item--small.el-form-item {
          padding-bottom: 30px;
        }
        .el-form-item__content {
          font-size: 12px;
          line-height: 1;
        }
      }
      .delete {
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .purchase-number::before {
        content: '*';
        color: red;
      }
      .item-img-content {
        .item-img-content-top {
          display: flex;
          align-items: flex-start;
          .item-img-content-row {
            height: 70px;
            display: flex;
            font-size: 12px;
            flex-direction: column;
            justify-content: space-between;
            .item-img-content-column {
              line-height: 1;
              .item-img-btn {
                font-size: 12px;
                line-height: 1;
                color: #0064c8;
                margin-top: 10px;
                text-align: center;
                cursor: pointer;
              }
              .img-relative {
                display: block;
                width: 68px;
                height: 68px;
              }
              .img-absolute {
                width: 20px;
                height: 25px;
                position: absolute;
                left: 6px;
                top: 0;
              }
              .item-img-content-name {
                font-size: 12px;
                line-height: 16px;

                color: #333333;
              }
            }
            li:nth-child(2) {
              margin: 0 10px;
            }
            li:nth-child(3) {
              margin-right: 10px;
            }
          }
        }
      }
    }
    border-color: #d9d9d9;
    &::before {
      background: #d9d9d9;
    }
    .el-table--border {
      &::after {
        background: #d9d9d9;
      }
    }
  }
}

.top {
  display: flex;
  justify-content: space-between;
  justify-items: center;
  height: 40px;
  line-height: 40px;
  padding-left: 20px;
  padding-right: 20px;
  background-color: #f5f5f5;
  border: 1px solid $border-color;
  border-bottom: none;
  font-size: 12px;
  color: #333;
  .top-header-left {
    color: #333333;
    font-weight: 700;
    display: flex;
  }
  .top-header-right {
    display: flex;
    justify-items: center;
    .approver {
      display: flex;
      span {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
    .order-status-text {
      color: #333;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-left: 20px;
    }
  }
}
.item-row {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  line-height: 1;
  .item-row-column {
    display: flex;
    margin-bottom: 10px;
    flex-direction: column;
    .item-row-column-desc {
      white-space: nowrap;
      font-size: 12px;
      display: flex;
      align-items: center;
      color: #999999;
      margin-bottom: 8px;
    }
    .item-row-column-content {
      line-height: 16px;
      font-size: 12px;
      color: #333333;
    }
  }
}

.choose-btn {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.item-img-content {
  .item-img-content-top {
    display: flex;
    align-items: flex-start;
    .item-img-content-row {
      height: 70px;
      display: flex;
      font-size: 12px;
      flex-direction: column;
      justify-content: space-between;
      .item-img-content-column {
        line-height: 1;
        .item-img-btn {
          font-size: 12px;
          line-height: 1;
          color: #0064c8;
          margin-top: 10px;
          text-align: center;
          cursor: pointer;
        }
        .img-relative {
          display: block;
          width: 68px;
          height: 68px;
        }
        .img-absolute {
          width: 20px;
          height: 25px;
          position: absolute;
          left: 6px;
          top: 0;
        }
        .item-img-content-name {
          font-size: 12px;
          line-height: 16px;

          color: #333333;
        }
      }
      li:nth-child(2) {
        margin: 0 10px;
      }
      li:nth-child(3) {
        margin-right: 10px;
      }
    }
  }
}

/* .item-img-content {
  width: 280px;
  .item-img-content-top {
    display: flex;
    align-items: flex-start;

    .item-img-content-row {
      display: flex;
      font-size: 14px;
      flex-direction: column;

      .item-img-content-column {
        line-height: 1;
        .item-img-btn {
          font-size: 14px;
          line-height: 14px;
          color: #0064c8;
          margin-top: 10px;
          text-align: center;
        }
        .img-relative {
          width: 70px;
          height: 70px;
        }
        .img-absolute {
          width: 20px;
          height: 25px;
          position: absolute;
          left: 6px;
          top: 0;
        }
        .item-img-content-name {
          font-size: 14px;
          line-height: 20px;

          color: #333333;
        }
      }
      li:nth-child(2) {
        margin: 0 10px;
      }
      li:nth-child(3) {
        margin-right: 10px;
      }
    }
  }
  .item-img-content-bottom {
    display: flex;
    margin-top: 18px;
    color: #999;
    font-size: 12px;
    .real-name {
      width: 92px;
    }
    .phone {
      width: 139px;
    }
    .dept {
      width: 236px;
    }
    .break {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    span:nth-child(2) {
      margin: 0 10px;
    }
  }
} */
.agreement-dialog {
  ::v-deep .el-dialog__body {
    padding: 20px;
  }
  ::v-deep .el-dialog__footer {
    padding: 0;
  }
}
.close-btn {
  margin-top: 20px;
  width: 100%;
  display: flex;
  justify-content: right;
}
.btn-other {
  border-color: #2587ff;
  color: #2587ff;
  border-radius: 0;
}
.select-agreement {
  width: 100%;
  height: 30px;
  display: flex;
  margin: 10px 0 10px;
  padding-left: 6px;
  box-sizing: border-box;
  align-items: center;
  font-size: 14px;
  & > span {
    position: relative;
  }
  & > span::before {
    content: '*';
    position: absolute;
    color: red;
    left: -8px;
    top: 2px;
  }
}
.order-number {
  /* margin-top: 10px; */
  .margin-b10 {
    margin-bottom: 10px;
  }
  .top {
    display: flex;
    justify-content: space-between;
    justify-items: center;
    height: 40px;
    line-height: 40px;
    padding-left: 20px;
    padding-right: 20px;
    background-color: #f5f5f5;
    border: 1px solid $border-color;
    //border-bottom: 1px solid $border-color;
    box-sizing: border-box;
    .top-header-left {
      color: #333333;
      font-weight: 700;
      display: flex;
    }
    .top-header-right {
      display: flex;
      justify-items: center;
      .approver {
        display: flex;
        span {
          width: 70px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
      .order-status-text {
        color: #333;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-left: 20px;
        .img-show {
          width: 18px;
          height: 18px;
          margin-left: 10px;
          background: url('~@/assets/img/purchase/help-gray.png') center
            no-repeat;
          background-size: 18px 18px;
          &:hover {
            background: url('~@/assets/img/purchase/help-gray-active.png')
              center no-repeat;
            background-size: 18px 18px;
          }
        }
      }
    }
  }
  .middle-view {
    display: flex;
    align-items: center;
    padding: 10px;
    padding-right: 0;
    padding-left: 0;
    box-sizing: border-box;
    border: 1px solid $border-color;
    border-top: none;
    height: 115px;
    .item-index {
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 50px;
    }
    .item-desc {
      height: 100%;
      border-left: 1px solid $border-color;
      padding: 0 20px 0 20px;

      display: flex;
      flex-direction: column;

      .item-desc-title {
        font-size: 14px;
        line-height: 14px;
        display: flex;
        align-items: center;

        color: #999999;
        margin-bottom: 8px;
      }
      .item-desc-content {
        width: 200px;
        color: #333;
      }
    }
    .item-unit {
      display: flex;
      flex-direction: column;
      border-left: 1px solid $border-color;
      padding: 0 20px 0 20px;
      height: 100%;
      .item-row {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        width: 142px;
        .item-row-column {
          display: flex;
          flex-direction: column;
          .item-row-column-desc {
            font-size: 14px;
            line-height: 14px;
            display: flex;
            align-items: center;
            color: #999999;
          }
          .item-row-column-content {
            font-size: 14px;
            line-height: 14px;
            color: #333333;
            margin-top: 8px;
            margin-bottom: 8px;
          }
        }
      }
    }
    .item-img {
      border-left: 1px solid $border-color;
      padding: 0 20px 0 20px;
      height: 100%;
      .item-img-content {
        width: 280px;

        .item-img-content-top {
          display: flex;
          align-items: flex-start;

          .item-img-content-row {
            display: flex;
            font-size: 14px;
            flex-direction: column;

            /* margin-right: 10px; */
            /* .break{
            text-overflow: -o-ellipsis-lastline;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
          } */
            .item-img-content-column {
              line-height: 1;
              .item-img-btn {
                font-size: 14px;
                line-height: 14px;
                color: #0064c8;
                margin-top: 10px;
                text-align: center;
              }
              .img-relative {
                width: 70px;
                height: 70px;
              }
              .img-absolute {
                width: 20px;
                height: 25px;
                position: absolute;
                left: 6px;
                top: 0;
              }
              .item-img-content-name {
                font-size: 14px;
                line-height: 20px;

                color: #333333;
              }
            }
            li:nth-child(2) {
              margin: 0 10px;
            }
            li:nth-child(3) {
              margin-right: 10px;
            }
          }
        }
        .item-img-content-bottom {
          display: flex;
          margin-top: 18px;
          color: #999;
          font-size: 12px;
          .real-name {
            width: 92px;
          }
          .phone {
            width: 139px;
          }
          .dept {
            width: 236px;
          }
          .break {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          span:nth-child(2) {
            margin: 0 10px;
          }
        }
      }
    }
    .item-name {
      display: flex;
      flex-direction: column;
      /* margin-bottom: 10px; */
      padding: 0 20px 0 20px;
      border-left: 1px solid $border-color;
      height: 100%;
      box-sizing: border-box;
      width: 130px;
      justify-content: center;
      .item-name-nick {
        color: #999999;
        margin-bottom: 10px;
      }
      .item-name-nick:before {
        content: '* ';
        color: red;
        vertical-align: middle;
        display: inline-block;
      }
      ::v-deep .el-input__inner {
        height: 30px;
        border-radius: 0 !important;
      }
      ::v-deep .el-form-item__label {
        padding: 0px 0 0px;
        line-height: 1;
      }
      ::v-deep .el-form-item {
        margin-bottom: 0 !important;
      }
      ::v-deep .el-form-item__error {
        padding-top: 0px;
      }
    }
    .item-detail {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      border-left: 1px solid $border-color;
      height: 100%;
      box-sizing: border-box;
      width: 113px;
      font-size: 14px;
      color: #0064c8;
      .is-active {
        border-bottom: 1px solid #0064c8;
      }
      div {
        cursor: pointer;
        color: #0064c8;
        border-bottom: 1px solid transparent;
        &:hover,
        :active {
          color: #2782ec;
          border-bottom: 1px solid #0064c8;
        }
      }

      .active {
        color: #2782ec;
      }
    }
  }
  .bottom-view {
    display: flex;
    justify-content: space-between;
    padding: 0 20px;
    height: 40px;
    line-height: 40px;
    border: 1px solid $border-color;
    border-top: none;

    .bottom-view-left {
      font-weight: 400;
      color: #333;
      span {
        margin-left: 40px;
      }
      .more {
        color: #2f80ed;
        margin-left: 10px;
        cursor: pointer;
      }

      ::v-deep .el-tooltip_popper {
        width: 30px;
      }
    }
    .bottom-view-right {
      font-size: 14px;
      color: #999999;
    }
  }
  .no-data {
    text-align: center;
    margin-bottom: 80px;
    img {
      margin-top: 60px;
      width: 204px;
      height: 124px;
    }
    p {
      margin-top: 10px;
      color: #333;
      font-size: 16px;
      span {
        color: #2587ff;
        cursor: pointer;
      }
    }
  }
}
.img-relative[lazy='error'] {
  width: 70px !important;
  height: 70px !important;
}
.product-img[lazy='error'] {
  width: 70px !important;
  height: 70px !important;
}
.button-handle {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
  &.is-fixed {
    position: fixed;
    bottom: 0;
    width: 100%;
    left: 0;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
    z-index: 1;
  }
  .is-fixed-wrap-left {
    width: 180px;
    height: 100%;
  }
  .is-fixed-wrap {
    margin-left: 10px;
    width: 1040px;
    /* margin: 0 auto; */
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
.form ::v-deep .el-input__inner {
  height: 30px;
  border-radius: 0 !important;
}

::v-deep .el-dialog__body {
  padding: 10px 10px;
}

.product-info {
  position: relative;
  display: flex;
  /* align-items: center; */
  width: 280px;
  margin-left: 10px;
  .product-img {
    width: 70px;
    height: 70px;
    border: 1px solid #e2e2e2;
    box-sizing: border-box;
  }

  .product-img-icon {
    position: absolute;
    top: 11px;
    left: 6px;
    width: 20px;
    height: 20px;
  }

  .product-info-right {
    display: flex;
    flex-direction: column;
    margin-left: 10px;

    .two-line {
      text-overflow: -o-ellipsis-lastline;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }

    > div {
      align-self: flex-start;
    }

    .title {
      width: 208px;
      text-align: left;
      color: #333333;
      line-height: 1;
      margin-bottom: 8px;
      font-size: 12px;
    }

    .num {
      color: #999;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      width: 208px;
      font-size: 12px;
      line-height: 1;
      text-align: left;
    }

    .provider {
      font-size: 12px;
      color: #999;
      text-align: left;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      width: 208px;
      line-height: 1;
      margin-top: 8px;
    }

    .footer {
      display: flex;
      justify-content: flex-start;

      p {
        width: 48px;
        height: 20px;
        line-height: 20px;
        text-align: center;
        color: #ffffff;
        margin-left: 10px;
        border-radius: 5px;
        font-size: 12px;
      }

      .authenticated {
        background-color: $button-background-color;
      }

      .easy-all-pass {
        background-color: $button-background-color2;
      }
    }
  }
}

.request-table {
  .request-table-row {
    background: #f5f5f5;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 40px;
    border: 1px solid #dcdcdc;
    .request-table-column {
      height: 100%;
      text-align: center;
      font-size: 14px;
      color: #333333;
      display: flex;
      justify-content: center;
      align-items: center;
      .product-info {
        position: relative;
        display: flex;
        /* align-items: center; */
        width: 280px;
        margin-left: 10px;
        .product-img {
          width: 70px;
          height: 70px;
          border: 1px solid #e2e2e2;
          box-sizing: border-box;
        }

        .product-img-icon {
          position: absolute;
          top: 11px;
          left: 6px;
          width: 20px;
          height: 20px;
        }

        .product-info-right {
          display: flex;
          flex-direction: column;
          margin-left: 10px;

          .two-line {
            text-overflow: -o-ellipsis-lastline;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
          }

          > div {
            align-self: flex-start;
          }

          .title {
            width: 208px;
            text-align: left;
            color: #333333;
            line-height: 1;
            margin-bottom: 10px;
          }

          .num {
            color: #999;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            width: 208px;
            font-size: 14px;
            line-height: 14px;
            text-align: left;
            line-height: 1;
          }

          .provider {
            font-size: 12px;
            color: #999;
            text-align: left;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            width: 208px;
            line-height: 1;
          }

          .footer {
            display: flex;
            justify-content: flex-start;

            p {
              width: 48px;
              height: 20px;
              line-height: 20px;
              text-align: center;
              color: #ffffff;
              margin-left: 10px;
              border-radius: 5px;
              font-size: 14px;
            }

            .authenticated {
              background-color: $button-background-color;
            }

            .easy-all-pass {
              background-color: $button-background-color2;
            }
          }
        }
      }
    }
  }
  &::-webkit-scrollbar {
    width: 1px;
  }
  &::-webkit-scrollbar-button {
    display: none;
  }
  &::-webkit-scrollbar-thumb {
    background: rgba(144, 147, 153, 0.3);
    cursor: pointer;
  }
}
</style>
